export const config = {
	"mainnet": {
		"mmfa": {
			"abi": require("./abis/mmfa.json"),
			"bpt-abi": require("./abis/bpt.json"),
			"address": "0x7acea008bdfe4fe24edc186c7b82d71f70d27d9a",
			"bpt-address": "0x1f0b203409233345a9d3c87a0310db58e5198bb8",
			"ratio": 1000
		},
		

	}
}


